// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1_xuj","cls2":"News-cls2_vM3 News-cls1_xuj"};